<template>
  <v-container>
    <!-- <Breadcrumbs :breadcrumbs="breadcrumbs" /> -->
    <v-form ref="form" lazy-validation>
      <v-card
        elevation="3"
        style="border: 1px solid #e0e0e0"
        class="mb-6 pt-3 pb-3"
      >
        <!-- bookUpload.bookName -->
        <v-row>
          <v-col cols="12" lg="6" class="pb-0">
            <TextField
              :rules="[rules.required]"
              v-model="bookInformation.bookname"
              class="mx-3"
              :label="$t('bookUpload.bookName')"
              outlined
              dense
              prepend-icon="mdi-pen"
            ></TextField>

            <AutoComplate
              v-if="bookInformation.Lang != null"
              :rules="[rules.required]"
              v-model="bookInformation.langid"
              class="mx-3"
              :items="listLang"
              dense
              :label="$t('bookUpload.lang')"
              outlined
              item-text="langname"
              item-value="langid"
              prepend-icon="mdi-web"
            ></AutoComplate>

            <AutoComplate
              :rules="[rules.requiredArray]"
              v-model="categoriesObject"
              :items="categoriesObject"
              outlined
              dense
              :readonly="true"
              chips
              class="mx-3"
              small-chips
              :label="$t('bookUpload.categories')"
              multiple
              item-text="categoryname"
              item-value="categoryid"
              @focus="dialogCategoryTree = true"
              prepend-icon="mdi-layers-triple"
            ></AutoComplate>
            <v-textarea
              v-model="bookInformation.bookdsecription"
              class="mx-3"
              :label="$t('bookUpload.bookDsecription')"
              outlined
              dense
            ></v-textarea>
          </v-col>

          <v-col cols="12" lg="6" class="pb-0">
            <AutoComplate
              clearable
              v-if="bookInformation.author != null"
              :search-input.sync="authorNameSearch"
              v-model="bookInformation.author.authorid"
              class="mx-3"
              :items="listAuthors"
              dense
              :label="$t('bookUpload.authorName')"
              outlined
              item-text="authorname"
              item-value="authorid"
              @keyup="searchAuthor()"
              prepend-icon="mdi-account-edit"
            ></AutoComplate>
            <!-- append-outer-icon="mdi-plus-circle"
            @click:append-outer="addDialogAuthor = true" -->
            <AutoComplate
              clearable
              v-if="bookInformation.publisher != null"
              :search-input.sync="publisherNameSearch"
              v-model="bookInformation.publisher.publisherid"
              class="mx-3"
              :items="listPublishers"
              dense
              :label="$t('bookUpload.publisher')"
              outlined
              item-text="publishername"
              item-value="publisherid"
              @keyup="searchPublishers()"
              prepend-icon="mdi-home"
            ></AutoComplate>
            <!-- append-outer-icon="mdi-plus-circle"
              @click:append-outer="addDialogPublisher = true" -->
            <TextField
              clearable
              v-if="bookInformation.publisher != null"
              v-model="bookInformation.publisher.year"
              class="mx-3"
              :label="$t('bookUpload.publisherYear')"
              outlined
              dense
              prepend-icon="mdi-calendar-range"
            ></TextField>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <TextField
                  v-model="bookInformation.booklink"
                  class="mx-3"
                  :label="$t('bookUpload.bookDriveLink')"
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  prepend-icon="mdi-link-variant-plus"
                  append-icon="mdi-information"
                  @click:append="goToYoutupe"
                ></TextField>
              </template>
              <span>{{ $t("bookUpload.googleDriveType") }}</span>
            </v-tooltip>
            <v-row>
              <v-col cols="6">
                <v-switch
                  class="mx-3"
                  v-model="bookInformation.isdownloadable"
                  flat
                  :label="$t('bookUpload.IsDownloadable')"
                ></v-switch>
              </v-col>
              <v-col cols="6">
                <v-switch
                  class="mx-3"
                  v-model="bookInformation.ispublish"
                  flat
                  :label="$t('bookUpload.IsPublish')"
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        elevation="3"
        style="border: 1px solid #e0e0e0"
        class="mb-6 pt-3 pb-3"
      >
        <div v-if="bookInformation.MetaData != null">
          <v-row
            no-gutters
            v-for="(item, index) in bookInformation.MetaData"
            :key="index"
          >
            <v-col md="6" cols="5" class="px-2">
              <TextField
                class="mt-6"
                :label="$t('bookUpload.metaName')"
                :rules="[rules.required]"
                v-model="item.name"
                outlined
                dense
              >
              </TextField>
            </v-col>
            <v-col md="5" cols="5" class="px-1">
              <TextField
                class="mt-6"
                :label="$t('bookUpload.metaValue')"
                :rules="[rules.required]"
                v-model="item.value"
                outlined
                dense
              >
              </TextField
            ></v-col>
            <v-col md="1" cols="2" class="px-1 text-center"
              ><span
                style="cursor: pointer"
                class=""
                @click="removerMeta(index)"
                ><i class="pt-6 status fa fa-times-circle red--text"></i></span
            ></v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="success" @click="addMeta" class="mx-3">
                {{ $t("bookUpload.addMeta") }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-col cols="12" class="pb-0">
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-3"
            color="primary"
            @click="submit()"
            :loading="loadingAdd"
          >
            {{ $t("public.upload") }}
          </v-btn>
        </v-card-actions>

        <v-spacer></v-spacer>
      </v-col>
    </v-form>
    <SelectTreeCategory
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="closeCategory($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />
    <AddAuthor
      :addDialog="addDialogAuthor"
      v-on:DialogClose="DialogClose($event)"
    />
    <AddPublisher
      :addDialog="addDialogPublisher"
      v-on:DialogClose="DialogClose($event)"
    />
  </v-container>
</template>

<style >
.status {
  font-size: 20px;
  position: relative;
  top: 9px;
}
</style>

<script>
// import Breadcrumbs from "@/components/Global/Breadcrumbs";
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";
import AddAuthor from "@/components/Authors/AddAuthor";
import AddPublisher from "@/components/Publishers/AddPublisher";

import TextField from "@/components/Elements/TextField";
import AutoComplate from "@/components/Elements/AutoComplate";

export default {
  data() {
    return {
      loadingAdd: false,
      categoriesObject: [],
      listLang: [],
      dialogCategoryTree: false,
      authorNameSearch: "",
      listAuthors: [],
      authorID: "",
      addDialogAuthor: false,
      publisherNameSearch: "",
      addDialogPublisher: false,
      listPublishers: [],

      bookInformation: {},
      rules: {
        required: (value) => !!value || this.$t("valid.required"),
        requiredArray: (value) => value != "" || this.$t("valid.required"),
      },
    };
  },
  created() {
    if (this.$route.params.bookData == null) {
      this.$router.push({ name: "MyBooks" }).catch(() => {});
      return false;
    }
    this.bookInformation = this.$route.params.bookData.BookInformation;
    this.bookInformation.bookdsecription = "";
    this.bookInformation.isdownloadable = true;
    this.bookInformation.ispublish = true;

    this.bookInformation.langid = this.bookInformation.Lang.langid;
    this.bookInformation.booklink = "";

    this.getAllLang();
    this.getAllAuthors();
    this.getAllPublishers();
  },

  components: {
    SelectTreeCategory,
    AddAuthor,
    AddPublisher,

    TextField,
    AutoComplate,
  },

  // fd.append("_method", "PUT");
  methods: {
    submit() {
      let metainfo = [];
      for (
        let index = 0;
        index < this.bookInformation.MetaData.length;
        index++
      ) {
        let obj = {};
        obj["meta_name"] = this.bookInformation.MetaData[index]["name"];
        obj["meta_value"] = this.bookInformation.MetaData[index]["value"];

        metainfo.push(obj);
      }
      // "_method", "PUT"
      this.bookInformation["_method"] = "PUT";
      this.bookInformation.metainfo = metainfo;
      if (this.$refs.form.validate() != false) {
        this.loadingAdd = true;
        let DataForm = {
          Param: this.bookInformation,
          API: "/uploader",
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then(() => {
            this.loadingAdd = false;
            this.$store.dispatch(
              "PushSuccessMsg",
              this.$t("public.successSeved")
            );
            this.$router.push({ name: "MyBooks" }).catch(() => {});
          })
          .catch((error) => {
            this.loadingAdd = false;
            this.$store.dispatch(
              "PushErrorMsg",
              error.data.data[Object.keys(error.data.data)[0]]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", this.$t("public.DataNotValid"));
      }
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/lang").then((response) => {
        this.listLang = response["data"]["data"];
      });
    },
    closeCategory() {
      this.dialogCategoryTree = false;
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.categoriesObject = vals;
      let categoryID = [];
      for (let index = 0; index < vals.length; index++) {
        categoryID.push(vals[index]["categoryid"]);
      }
      this.dialogCategoryTree = false;
      this.bookInformation.category = categoryID;
    },
    removerMeta(index) {
      this.bookInformation.MetaData.splice(index, 1);
    },
    getAllAuthors() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/author?per_page=20&filter[authorname]=" + this.authorNameSearch
        )
        .then((response) => {
          this.listAuthors = response["data"]["data"];
          this.listAuthors.push({
            authorid: this.bookInformation.author.authorid,
            authorname: this.bookInformation.author.authorname,
          });
        });
    },
    searchAuthor() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllAuthors();
      }
    },
    DialogClose() {
      this.addDialogAuthor = false;
      this.addDialogPublisher = false;
      this.getAllAuthors();
    },
    getAllPublishers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/publisher?per_page=20&filter[publishername]=" +
            this.publisherNameSearch
        )
        .then((response) => {
          this.listPublishers = response["data"]["data"];
          this.listPublishers.push({
            publisherid: this.bookInformation.publisher.publisherid,
            publishername: this.bookInformation.publisher.publishername,
            year: this.bookInformation.publisher.year,
          });
        });
    },
    searchPublishers() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllPublishers();
      }
    },
    addMeta() {
      this.bookInformation.MetaData.push({ name: "", value: "" });
    },
    goToYoutupe() {
      window.open(
        "https://www.youtube.com/watch?v=dRSRXPmgMqU&t=223s",
        "_blank"
      );
    },
  },
};
</script>